import {marked} from 'marked';

export async function parseMultilingualMarkdown(contents: string, currentLang: string): Promise<string> {
    let processed = contents;

    if (contents.includes('&lt;') || contents.includes('&gt;')) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = contents;
        processed = textarea.value;
    }

    const langPattern = /<div\s+lang=["'](\w+)["']>(.*?)<\/div>/gs;

    processed = processed.replace(langPattern, (_, lang, content) => {
        if (lang === currentLang) {
            return content.trim();
        }
        return '';
    });

    return marked.parse(processed);
}
